import React from 'react';
import { Sparkles } from 'lucide-react';

interface KaneaIconProps {
  size?: number;
  color?: string;
}

export const KaneaIcon: React.FC<KaneaIconProps> = ({ size = 20, color = "#22c55e" }) => {
  return <Sparkles size={size} color={color} />;
};
